import { Link, NavLink } from 'react-router-dom';

const QUICK_TABS = [
  { to: '/', label: '首页', icon: 'ri-home-5-line' },
  { to: '/category/movie', label: '电影', icon: 'ri-film-line' },
  { to: '/category/tv', label: '电视剧', icon: 'ri-tv-2-line' },
  { to: '/category/variety', label: '综艺', icon: 'ri-mic-line' },
];

export default function MobileBottomNav() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-background-200 bg-background-50/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-md md:hidden">
      <div className="mx-auto grid max-w-md grid-cols-4">
        {QUICK_TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.to === '/'}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
                isActive ? 'text-primary-600' : 'text-foreground-500'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <i className={`${tab.icon} text-xl ${isActive ? 'text-primary-600' : ''}`} />
                {tab.label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}